import SEO from '@/components/feature/SEO';
import HeroBanner from './components/HeroBanner';
import CategorySection from './components/CategorySection';
import HotVideos from './components/HotVideos';
import LatestVideos from './components/LatestVideos';
import StatsSection from './components/StatsSection';
import WhyUsSection from './components/WhyUsSection';
import CTASection from './components/CTASection';

export default function Home() {
  const schemaJson = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '桔子视频 - 首页',
      description: '桔子视频聚合红桃视频、樱桃视频等热门视频平台内容，提供免费在线观看高清电视剧全集，茄子视频、糖心视频同步收录。',
      url: 'https://juzi.video/',
      isPartOf: {
        '@type': 'WebSite',
        name: '桔子视频',
        url: 'https://juzi.video/',
      },
    },
  ];

  return (
    <>
      <SEO
        title="桔子视频 | 红桃视频樱桃视频免费在线观看 | 茄子视频糖心视频电视剧全集高清"
        description="桔子视频聚合红桃视频、樱桃视频等热门视频平台内容，提供免费在线观看高清电视剧全集，茄子视频、糖心视频同步收录，不缓冲流畅播放，视频大全尽在掌握。"
        keywords="桔子视频,红桃视频,樱桃视频,茄子视频,糖心视频,免费在线观看,高清全集,电视剧大全,不缓冲"
        canonicalUrl="https://juzi.video/"
        schemaJson={schemaJson}
      />

      <main>
        <HeroBanner />
        <CategorySection />
        <HotVideos />
        <StatsSection />
        <LatestVideos />
        <WhyUsSection />
        <CTASection />
      </main>
    </>
  );
}